import { render, staticRenderFns } from "./ExerciseItem.vue?vue&type=template&id=0f16aea6&scoped=true&"
import script from "./ExerciseItem.vue?vue&type=script&lang=js&"
export * from "./ExerciseItem.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseItem.vue?vue&type=style&index=0&id=0f16aea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f16aea6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VIcon,VProgressCircular,VToolbarTitle})
